import { FlexibleConnectedPositionStrategy, Overlay, OverlayRef, VerticalConnectionPos } from '@angular/cdk/overlay';
import { AfterViewInit, Directive, ElementRef, HostListener, Input, OnDestroy, TemplateRef, ViewContainerRef } from '@angular/core';
import { HorizontalPosition } from '@tekman/onmat/constants';
import { fromEvent, Subscription } from 'rxjs';
import { DropdownMenuService } from '../service/dropdown/dropdown.service';

const OFFSET = 15;

@Directive({
  selector: '[sharedDropdownMenu]',
})
export class DropdownDirective implements AfterViewInit, OnDestroy {
  @Input() horizontalPosition: HorizontalPosition = 'left';
  @Input() verticalPosition: VerticalConnectionPos = 'bottom';
  @Input() outElement = false;
  @Input() sharedDropdownMenu: TemplateRef<any>;

  private isOpen = false;
  private eventSubscription: Subscription = new Subscription();
  private overlayRef: OverlayRef | null;

  constructor(
    public overlay: Overlay,
    public elementRef: ElementRef,
    public viewContainerRef: ViewContainerRef,
    private dropdownMenuService: DropdownMenuService
  ) {}

  ngOnDestroy(): void {
    this.eventSubscription.unsubscribe();
    this.detachOverlayIfExists();
  }

  ngAfterViewInit(): void {
    this.eventSubscription.add(
      fromEvent(this.elementRef.nativeElement, 'click').subscribe(() => {
        if (this.isOpen === true) {
          this.detachOverlayIfExists();
        } else {
          this.openDropdownMenu();
        }
      })
    );
  }

  openDropdownMenu(): void {
    this.isOpen = true;
    this.dropdownMenuService.subjectOverlay.next(this.isOpen);

    const positionStrategy = this.getPosition(this.elementRef);
    this.overlayRef = this.dropdownMenuService.createOverlayRef(positionStrategy, this.overlay);

    this.overlayRef.attach(this.dropdownMenuService.createPortal(this.sharedDropdownMenu, this.viewContainerRef));

    this.eventSubscription.add(
      this.overlayRef.backdropClick().subscribe(() => {
        this.detachOverlayIfExists();
      })
    );
  }

  getPosition(el: ElementRef<any>): FlexibleConnectedPositionStrategy {
    const boundingClientRects = el.nativeElement.getBoundingClientRect();
    const y = boundingClientRects[this.verticalPosition];
    let x = boundingClientRects[this.horizontalPosition];

    if (this.outElement) {
      x = x + (boundingClientRects.right - boundingClientRects.left) + OFFSET;
    }

    return this.dropdownMenuService.getPosition(x, y, this.horizontalPosition, this.verticalPosition);
  }

  private detachOverlayIfExists() {
    if (this.overlayRef) {
      this.isOpen = false;
      this.dropdownMenuService.subjectOverlay.next(this.isOpen);
      this.overlayRef.detach();
    }
  }

  @HostListener('window:resize')
  onResize(): void {
    this.detachOverlayIfExists();
  }
}
